import GetAllResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import Constants from "../common/Constants";
import { IIndexTypeGroup } from "../model/IndexTypeGroup";
import IndexTypeGroupMapper from "../service/IndexTypeGroupMapper";
import IndexTypeGroupParamMapper from "../service/IndexTypeGroupParamMapper";

export default class GetAllGroupChildGroupsInteractor {
  private resource: GetAllResourceEntriesInteractor<IIndexTypeGroup>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute(groupId: number) {
    return this.resource.execute(
      `${Constants.indexGroupBasePath}/${groupId}/child-groups`,
      IndexTypeGroupMapper,
      IndexTypeGroupParamMapper
    );
  }
}
